export class FilterTabs {
    static Tabs = [
        { id: "0", TabName: 'DosageType', component: "" },
        { id: "1", TabName: 'BatchNo', component: "" },
        { id: "2", TabName: 'Quantity', component: "" },
        { id: "3", TabName: 'MRP/Qty(₹)', component: "" },
        { id: "4", TabName: 'BuyingPrice', component: "" },
        { id: "5", TabName: 'ExpiryDate', component: "" },
    ];
}